import styled from '@emotion/styled'
import { space, color, H4, device } from '@ticketswap/solar'

export const Block = styled.div`
  margin-block-end: ${space[32]};

  @media ${device.tablet} {
    margin-block-end: ${space[64]};
  }
`

export const BlockHeader = styled.header`
  margin-block-end: ${space[16]};
`

export const BlockSubtitle = styled(H4)`
  margin-block-start: ${space[4]};
  color: ${color.foregroundMuted};
`
